export default __webpack_public_path__ + "static/media/tehniki-na-testiranje.4bcf68c9.gif";